const apiUrl="https://api-prompts.vercel.app/api";

export default apiUrl